import { Suspense, useEffect } from 'react'

import {
  EventMessage,
  EventType,
  IPublicClientApplication,
} from '@azure/msal-browser'
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import '@mui/material/styles/createPalette'
import { Toaster } from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { RouterProvider } from 'react-router-dom'

import LazyLoader from 'components/LazyLoad'
import Login from 'pages/Login'
import { fetchAuthClaims, setLoading } from 'store/features/authSlice'
import { useAppDispatch } from 'store/hooks'
import ThemeConfig from 'theme/index'

import packageJson from '../package.json'
import './index.css'

import Routes from './routes/index'

interface AppProps {
  pca: IPublicClientApplication
}

function App({ pca }: AppProps) {
  const dispatch = useAppDispatch()
  const directDispatch = useDispatch()

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(`App version: ${packageJson.version}`)
  }, [])

  window.addEventListener('keydown', (event) => {
    if (
      event.key === 'Enter' &&
      !(document.activeElement?.tagName.toLowerCase() === 'textarea') &&
      !(document.activeElement?.id === 'id-requestId') &&
      !(document.activeElement?.id === 'login-email')
    ) {
      event.preventDefault()
    }
  })

  pca.addEventCallback((event: EventMessage | any) => {
    if (
      event.eventType === EventType.LOGIN_START ||
      event.eventType === EventType.ACQUIRE_TOKEN_START
    ) {
      directDispatch(setLoading(false))
    }
    if (event.payload && event.payload.accessToken) {
      directDispatch(setLoading(true))
      dispatch(fetchAuthClaims(event.payload.accessToken))
    }
  })

  return (
    <ThemeConfig>
      <MsalProvider instance={pca}>
        <AuthenticatedTemplate>
          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            toastOptions={{ duration: 5000 }}
          />
          <Suspense fallback={<LazyLoader />}>
            <RouterProvider router={Routes} />
          </Suspense>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </MsalProvider>
    </ThemeConfig>
  )
}

export default App
